import { render, staticRenderFns } from "./stationBoard.vue?vue&type=template&id=991be848&scoped=true"
import script from "./stationBoard.vue?vue&type=script&lang=js"
export * from "./stationBoard.vue?vue&type=script&lang=js"
import style0 from "./stationBoard.vue?vue&type=style&index=0&id=991be848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991be848",
  null
  
)

export default component.exports